export default class EventWebPageCustomSectionsViewModel {
  public static createEmpty(): EventWebPageCustomSectionsViewModel {
    return new EventWebPageCustomSectionsViewModel();
  }
  constructor(
    public Id = 0,
    public EventWebPagesMetaDataId = 0,
    public SectionTitle = '',
    public SectionImageUrl = '',
    public SectionDescription = '',
    public ShowSection = true,
    public IsDeleted = false,
  ){}
}
